import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Component, inject, OnInit} from '@angular/core';

import {ToastrService} from "ngx-toastr";

import {appRoutes} from "@numizmat/constants";
import {UserBlockApiService} from "@numizmat/services/core";
import {UserBlockResponse} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-blocked-users',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink
  ],
  templateUrl: './blocked-users.component.html',
  styleUrl: './blocked-users.component.scss'
})
export class BlockedUsersComponent implements OnInit {
  private toastrService: ToastrService = inject(ToastrService);
  private userBlockApiService: UserBlockApiService = inject(UserBlockApiService);

  protected loading: boolean = true;
  protected selectedUserBlockId?: string;
  protected loadingDeleteUserBlock: boolean = false;
  protected userBlocks: UserBlockResponse[] = [];

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getAllUserBlocks();
  }

  protected deleteUserBlock(userBlock: UserBlockResponse): void {
    this.loadingDeleteUserBlock = true;
    this.selectedUserBlockId = userBlock.userBlockId;
    this.userBlockApiService.deleteUserBlock(userBlock.userBlockId).subscribe({
      next: response => {
        this.loadingDeleteUserBlock = false;
        this.selectedUserBlockId = undefined;
        const index = this.userBlocks.findIndex(x => x.userBlockId === userBlock.userBlockId);
        this.userBlocks.splice(index, 1);
        this.toastrService.success(`Успешно премахнахте ${userBlock.blockedUsername} от списъка със забранени потребители.`);
      }
    });
  }

  private getAllUserBlocks(): void {
    this.userBlockApiService.getAllUserBlocks().subscribe({
      next: response => {
        this.loading = false;
        this.userBlocks = response;
      }
    });
  }
}
